import React from "react";
import NavBar from "../NavBar";
import Footer from "../Footer";
import HistoryContent from "./HistoryContent";

function HistoryMain() {
  return (
    <div className="p-3">
      {/*Add title and metadata */}
      <title>Search History Page</title>
      <meta name="robots" content="index, follow"></meta>
      <meta
        name="description"
        content="View all previous ai to humanizer, ai detector resiults. So that you don't need to wait for the same results again and again."
      ></meta>
      <meta
        name="keywords"
        content="ai detector,artificial intelligence detector,aı detector,ai detector free,chatgpt detector,ai detect,ai detecting,chatgpt detectors,detect ai,ai detection tool,gemini detector,bot detector,perplexity detector,copilot detector,"
      ></meta>

      {/*navbar*/}
      <NavBar />
      {/* History body */}
      <HistoryContent />
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default HistoryMain;
